import { CommunityBackButton } from '@/components/CommunityBackButton'
import { CommunityInfo } from '@/components/CommunityInfo'
import type { CommunityInfoProps } from '@/components/CommunityInfo'

export interface CommunityMapHeaderProps extends Omit<CommunityInfoProps, 'variant' | 'spacesClass' | 'className'> {
	onBack: () => void
	backLabel?: string
	/** Mobile layout: matches card view — a back row above the shared CommunityInfo box. */
	stacked?: boolean
	className?: string
}

/**
 * Header above a property's SightMap in portfolio map view. Map view has no list
 * controls, so this carries the way back out to the portfolio map.
 */
export function CommunityMapHeader ({
	onBack,
	backLabel,
	stacked = false,
	className = '',
	...info
}: CommunityMapHeaderProps) {
	const backButton = <CommunityBackButton onBack={onBack} label={backLabel} />

	if (stacked) {
		// Mirrors the card view list controls + CommunityInfo so both views read the same on mobile.
		return (
			<div className={`spaces-community-map-header spaces:shrink-0 spaces:bg-canvas-base ${className}`}>
				<div className='spaces:flex spaces:items-center spaces:pl-8 spaces:pr-12 spaces:py-8 spaces:border-b spaces:border-canvas-3'>
					{backButton}
				</div>
				<div className='spaces:p-12'>
					<CommunityInfo {...info} />
				</div>
			</div>
		)
	}

	return (
		<div className={`spaces-community-map-header spaces:shrink-0 spaces:flex spaces:items-center spaces:justify-between spaces:gap-12 spaces:pl-12 spaces:pr-16 spaces:py-12 spaces:border-b spaces:border-canvas-3 spaces:bg-canvas-base ${className}`}>
			{backButton}
			<CommunityInfo {...info} variant='inline' spacesClass='spaces-community-map-details' />
		</div>
	)
}
